import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttperrorhandlerService } from '../main/shared/http/httperrorhandler.service';
import { ProjConstants } from './proj.constant';

@Injectable({
  providedIn: 'root'
})
export class MapService {

  minZoom: number = 5;
  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService) { }

  getMapOptions(stateName, projconst) {
    // console.log(stateName + '_ZOOM_LEVEL');
    // console.log(projconst['ANDHRA PRADESH_ZOOM_LEVEL']);
    const MAP_OPTIONS = {
      minZoom: 5,
      maxZoom: 14,
      zoomSnap: 1,
      zoom: projconst[stateName + '_ZOOM_LEVEL'],
      center: projconst[stateName + '_CENTER'],
      zoomControl: false,
      zoomAnimation: true,
      maxBounds: [
        [40, 66],
        [5, 99]
      ],
      maxBoundsViscosity: 1.0,
    };
    return MAP_OPTIONS;
  }

  getMapGroupLists(stateName) {
    const GROUP_LIST = {
      BASE_LAYER: {
        groupName: 'baseLayers',
        LayerList: {
          BASE_LAYER1: {
            url: environment.url.AP_GEOSERVER_URL + 'gwc/service/wmts?layer=baselayer:irrigation_ap_base_layer&style&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
            options: {
              maxZoom: 10,
              opacity: 1,
              format: 'image/png',
              visible: true,
              transparent: true,
              pane: 'base'
            }
          },
          BASE_LAYER2: {
            url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png',
            options: {
              maxNativeZoom: 14,
              maxZoom: 14,
              visible: false
            }
          },
          BASE_LAYER3: {
            url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            options: {
              maxZoom: 22,
              maxNativeZoom: 18,
              visible: false
            }
          },
          BASE_LAYER4: {
            url: 'https://{s}.tile.openstreetmap.se/hydda/base/{z}/{x}/{y}.png',
            options: {
              maxZoom: 22,
              maxNativeZoom: 18,
              visible: false
            }
          }
        }
      },
      ADMIN_LAYER: {
        groupName: 'administrativeLayers',
        LayerList: {
          India_Block: {
            interactive: true,
            rendererFactory: {},
            opacity: 1,
            minZoom: 5,
            maxZoom: 18,
            pane: 'district',
            visible: true,
            transparent: true,
            vectorTileLayerStyles: {},
            getFeatureId: {}
          },
          ADMIN_LAYER_GROUP: {
            layers: 'forecast:INDIA_FORECAST_ADMIN',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            viewParams: 'stateName:' + stateName,
          },
          ADMIN_LAYER_GROUP_WITH_MASK: {
            layers: 'forecast:INDIA_FORECAST_ADMIN_WITH_MASK',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            viewParams: 'stateName:' + stateName,
          },
          BASIN_LAYER_GROUP: {
            layers: 'forecast:INDIA_FORECAST_BASIN',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            viewParams: 'stateName:' + stateName,
          },
          BASIN_LAYER_GROUP_WITH_MASK: {
            layers: 'forecast:INDIA_FORECAST_BASIN_WITH_MASK',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            viewParams: 'stateName:' + stateName,
          },
          BLOCK_LAYER: {
            layers: 'forecast:INDIA_BLOCK_FORECAST',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            minZoom: 9,
            viewParams: 'stateName:' + stateName,
          },
          SUBBASIN_LAYER: {
            layers: 'forecast:INDIA_SUBBASIN',
            opacity: 1,
            format: 'image/png',
            visible: true,
            transparent: true,
            pane: 'district',
            fadeAnimation: false,
            minZoom: 9,
            viewParams: 'stateName:' + stateName,
          }
        },
      },
      HYDROLOGICAL_LAYER: {
        groupName: 'hydrologicalLayers',
        LayerList: [{

        }]
      }
    };
    return GROUP_LIST;
  }

  setMinZoom(zoomLevel: number) {
    this.minZoom = zoomLevel;
  }

  getMiniMapOptions(stateName, projconst) {
    const MAP_OPTIONS = {
      minZoom: this.minZoom,
      maxZoom: 11,
      zoomSnap: 1,
      zoom: projconst[stateName + '_ZOOM_LEVEL'] - 2,
      center: projconst[stateName + '_CENTER'],
      zoomControl: false,
      zoomAnimation: true,
      attributionControl: false,
      maxBounds: [
        [40, 66],
        [5, 99]
      ],
      maxBoundsViscosity: 1.0,
    };
    return MAP_OPTIONS;
  }

  getGisMiniMapOptions(stateName, projconst) {
    const MAP_OPTIONS = {
      minZoom: 4,
      maxZoom: 11,
      zoomSnap: 0,
      zoom: projconst[stateName + '_ZOOM_LEVEL'] - 2,
      center: projconst[stateName + '_CENTER'],
      zoomControl: false,
      zoomAnimation: true,
      attributionControl: false,
      maxBounds: [
        [40, 66],
        [5, 99]
      ],
      maxBoundsViscosity: 1.0,
    };
    return MAP_OPTIONS;
  }

  getWidgetMapOptions(stateName, projconst) {
    //console.log('Test Zoom Level',projconst[stateName + '_ZOOM_LEVEL']);
    // console.log(projconst['ANDHRA PRADESH_ZOOM_LEVEL']);
    const MAP_OPTIONS = {
      minZoom: 5,
      maxZoom: 12,
      zoomSnap: 0.5,
      zoom: 2,
      //zoom: projconst[stateName + '_ZOOM_LEVEL'],
      center: projconst[stateName + '_CENTER'],
      zoomControl: true,
      zoomAnimation: true,
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
    };
    return MAP_OPTIONS;
  }

  getpdfDownload(source: string, component: string, forecastLength: string, timePeriod: string, view: string): Observable<any> {
    if (source == 'WINDSPEED-ACTUAL' || source == 'RAINFALL-ACTUAL') {
      let comp = source.split('-')[0];
      return this.getpdfDownloadForOW(comp, view);
    }
    return this.http.get<any>(ProjConstants.API_URL + 'weatherForecast/getReportPdf/' + component + '/' + source + '/' + forecastLength + '/' + timePeriod + '/' + view, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getImage(source: string, component: string, forecastLength: string, timePeriod: string, view: string): Observable<File> {
    if (source == 'WINDSPEED-ACTUAL' || source == 'RAINFALL-ACTUAL') {
      let comp = source.split('-')[0];
      return this.getImageForOW(comp, view);
    }
    const result: Observable<any> = this.http.get(ProjConstants.API_URL + 'weatherForecast/getReportImage/' + component + '/' + source + '/' + forecastLength + '/' + timePeriod + '/' + view, { responseType: 'blob' });
    return result;
  }

  getpdfDownloadForOW(component: string, view: string): Observable<any> {
    if (component == 'RAINFALL') {
      return this.http.get<any>(ProjConstants.API_URL + 'aw/getReportPdf/' + component + '/' + view, { responseType: 'blob' as 'json' }).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    } else if (component == 'WINDSPEED') {
      return this.http.get<any>(ProjConstants.API_URL + 'aw/ws/getWindReportPdf', { responseType: 'blob' as 'json' }).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    } else if (component == 'TEMPERATURE') {
      return this.http.get<any>(ProjConstants.API_URL + 'aw/temperature/getTemperatureReportPdf', { responseType: 'blob' as 'json' }).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    } else if (component == 'HUMIDITY') {
      return this.http.get<any>(ProjConstants.API_URL + 'aw/humidity/getHumidityReportPdf', { responseType: 'blob' as 'json' }).pipe(
        catchError(this.errorHandler.handleError('Kpi data request', []))
      );
    }
  }

  getImageForOW(component: string, view: string): Observable<File> {
    let result: Observable<any>;
    if (component == 'RAINFALL') {
      result = this.http.get(ProjConstants.API_URL + 'aw/getReportImage/' + component + '/' + view, { responseType: 'blob' });
    } else if (component == 'WINDSPEED') {
      result = this.http.get(ProjConstants.API_URL + 'aw/ws/getWindReportImage', { responseType: 'blob' });
    } else if (component == 'TEMPERATURE') {
      result = this.http.get(ProjConstants.API_URL + 'aw/temperature/getTemperatureReportImage', { responseType: 'blob' });
    } else if (component == 'HUMIDITY') {
      result = this.http.get(ProjConstants.API_URL + 'aw/humidity/getHumidityReportImage', { responseType: 'blob' });
    }
    return result;
  }

  getpdfDownloadForHW(source: string, component: string, forecastLength: string, timePeriod: string, view: string): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'heatWatches/getReportPdf/' + source, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }
  getImageForHW(source: string, component: string, forecastLength: string, timePeriod: string, view: string): Observable<File> {
    const result: Observable<any> = this.http.get(ProjConstants.API_URL + 'heatWatches/getReportImage/' + source, { responseType: 'blob' });
    return result;
  }

  getHeatWaveDownload(uuid, source): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'heatWatches/getReport/' + uuid + '/HEATWAVE/' + source, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getStateHeatWaveDownload(source): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'hw/getHeatWatchesReportForIndia/' + 'HEATWAVE/' + source, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getRainfallForecastReportCountry(source: string, reportType?: string): Observable<any> {
    let url = ProjConstants.API_URL + 'rainfall/report/getReport/' + source;
    if (reportType) {
      url += '?reportType=' + reportType;
    }
    return this.http.get<any>(url, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Rainfall report download', []))
    );
  }

  getRainfallForecastReportByLocation(locationUUID: string, source: string, reportType?: string): Observable<any> {
    let url = ProjConstants.API_URL + 'rainfall/report/getReport/' + locationUUID + '/' + source;
    if (reportType) {
      url += '?reportType=' + reportType;
    }
    return this.http.get<any>(url, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Rainfall report download', []))
    );
  }

  getCountryColdWaveDownload(source): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'hw/getHeatWatchesReportForIndia/' + 'COLDWAVE/' + source, { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getColdWaveDownload(uuid): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'heatWatches/getReport/' + uuid + '/COLDWAVE', { responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

}
